if (!customElements.get('no-respekt-builder')) {
  customElements.define('no-respekt-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.data = JSON.parse(this.querySelector('[data-builder-data]').textContent);
      this.state = { shape:'', size:'', camber:'', flex:'', flexName:'', construction:'Standard', carbon:'None', graphics:'', artworkPrep:false, topArtworkName:'', baseArtworkName:'' };
      this.bindEvents();
      this.restore();
      this.sync();
    }

    bindEvents() {
      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-option]');
        if (input) {
          const option = input.dataset.option;
          if (option === 'shape') {
            this.state.shape = input.value;
            if (!this.querySelector(`[data-sizes-for="${CSS.escape(input.value)}"] [data-size="${CSS.escape(this.state.size)}"]`)) this.state.size = '';
          }
          if (option === 'camber') this.state.camber = input.value;
          if (option === 'flex') { this.state.flex = input.value; this.state.flexName = input.dataset.flexName; }
          if (option === 'construction') this.state.construction = input.value;
          if (option === 'graphics') this.state.graphics = input.value;
          this.sync();
          return;
        }
        const artworkUpload = event.target.closest('[data-artwork-upload]');
        if (artworkUpload) {
          const artworkSide = artworkUpload.dataset.artworkSide;
          if (artworkSide === 'top') this.state.topArtworkName = artworkUpload.files?.[0]?.name || '';
          if (artworkSide === 'base') this.state.baseArtworkName = artworkUpload.files?.[0]?.name || '';
          this.sync();
          return;
        }
        const artworkPrep = event.target.closest('[data-artwork-prep]');
        if (artworkPrep) {
          this.state.artworkPrep = artworkPrep.checked;
          this.sync();
        }
      });
      this.addEventListener('click', (event) => {
        const size = event.target.closest('[data-size]');
        if (size) {
          event.preventDefault(); event.stopPropagation();
          const group = size.closest('[data-sizes-for]');
          const shape = group.dataset.sizesFor;
          const shapeInput = this.querySelector(`[data-option="shape"][value="${CSS.escape(shape)}"]`);
          shapeInput.checked = true;
          this.state.shape = shape; this.state.size = size.dataset.size;
          this.sync();
        }
        const artOption = event.target.closest('[data-art-option]');
        if (artOption) {
          event.preventDefault();
          const option = artOption.dataset.artOption;
          const value = artOption.dataset.value;
          const input = [...this.querySelectorAll(`[data-option="${option}"]`)].find((item) => item.value === value);
          if (input) input.checked = true;
          if (option === 'camber') this.state.camber = value;
          if (option === 'flex') { this.state.flex = value; this.state.flexName = artOption.dataset.flexName; }
          this.sync();
        }
        const specsToggle = event.target.closest('[data-toggle-specs]');
        if (specsToggle) {
          const specs = this.querySelector('[data-specs]');
          const collapsed = specs.classList.toggle('is-collapsed');
          specsToggle.setAttribute('aria-expanded', String(!collapsed));
          specsToggle.textContent = collapsed ? 'Show specs' : 'Hide specs';
        }
        const summaryToggle = event.target.closest('[data-summary-toggle]');
        if (summaryToggle) {
          const summary = this.querySelector('.nr-summary');
          const open = summary.classList.toggle('is-open');
          summaryToggle.setAttribute('aria-expanded', String(open));
        }
      });
      this.form.addEventListener('submit', (event) => this.submitBuild(event));
    }

    restore() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.dataset.storageKey));
        if (saved && typeof saved === 'object') Object.assign(this.state, saved);
      } catch (_) {}
      ['shape','camber','flex','construction','graphics'].forEach((key) => {
        const value = this.state[key];
        if (!value) return;
        const input = [...this.querySelectorAll(`[data-option="${key}"]`)].find((item) => item.value === value);
        if (input) { input.checked = true; if (key === 'flex') this.state.flexName = input.dataset.flexName; }
      });
    }

    sync() {
      this.querySelectorAll('[data-choice-card]').forEach((card) => card.classList.toggle('is-selected', Boolean(card.querySelector('input:checked'))));
      this.querySelectorAll('[data-size]').forEach((button) => {
        const selected = button.dataset.size === this.state.size && button.closest('[data-sizes-for]').dataset.sizesFor === this.state.shape;
        button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', String(selected));
      });
      this.querySelectorAll('[data-art-option]').forEach((button) => {
        const selected = this.state[button.dataset.artOption] === button.dataset.value;
        button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', String(selected));
      });
      const sizeInput = this.querySelector('[data-property="size"]');
      sizeInput.value = this.state.size;
      this.syncBoardVariant();
      this.updateSpecs();
      this.updateConstructionCopy();
      this.updatePro();
      this.updateUpgradePrice();
      this.updateGraphics();
      this.updateSummary();
      try { sessionStorage.setItem(this.dataset.storageKey, JSON.stringify(this.state)); } catch (_) {}
    }

    updateSpecs() {
      const panel = this.querySelector('[data-specs]');
      const spec = this.data.specs?.[this.state.shape]?.[this.state.size];
      panel.hidden = !spec;
      if (!spec) return;
      this.querySelector('[data-spec-title]').textContent = `${this.state.shape} ${this.state.size}`;
      Object.entries(spec).forEach(([key,value]) => { const target = this.querySelector(`[data-spec="${key}"]`); if (target) target.textContent = value; });
    }

    updateConstructionCopy() {
      const selectedFlex = this.state.flexName ? `The ${this.state.flexName} flex` : 'Your selected flex';
      const standard = this.querySelector('[data-standard-copy]');
      const pro = this.querySelector('[data-pro-construction-copy]');
      const layout = this.data.proLayouts?.[this.state.flexName];
      if (standard) standard.textContent = `${selectedFlex} combines our proven fiberglass layup with a precision-profiled core, engineered to deliver its intended balance of flex, strength, and response.`;
      if (pro) pro.textContent = layout ? layout.copy : "Choose a flex above to see how its purpose-built stitched UD carbon layout changes the board's pop, response, edge control, and stability.";
    }

    updatePro() {
      const pro = this.state.construction === 'Pro';
      const panel = this.querySelector('[data-pro-panel]');
      const layout = this.data.proLayouts?.[this.state.flexName];
      panel.hidden = !pro;
      this.state.carbon = pro && layout ? layout.property : 'None';
      this.querySelector('[data-property="carbon"]').value = this.state.carbon;
      if (!pro || !layout) return;
      this.querySelector('[data-pro-title]').textContent = layout.title;
      this.querySelector('[data-pro-copy]').textContent = layout.copy;
      this.querySelector('[data-pro-benefits]').innerHTML = layout.benefits.map((item) => `<li>${this.escape(item)}</li>`).join('');
      this.querySelector('[data-carbon-board]').dataset.layout = layout.layout;
    }

    proSurcharge() {
      const value = Number(this.data.proSurcharges?.[this.state.flexName]);
      return Number.isFinite(value) && value >= 0 ? Math.round(value) : 0;
    }

    graphicsSurcharge() {
      if (this.state.graphics === 'No Respekt custom design service') return 8000;
      if (this.state.graphics === 'Customer supplied artwork' && this.state.artworkPrep) return 2000;
      return 0;
    }

    selectedUpgradeTitles() {
      const titles = [];
      if (this.state.construction === 'Pro' && this.state.flexName) titles.push(`Pro — ${this.state.flexName}`);
      if (this.state.graphics === 'Customer supplied artwork' && this.state.artworkPrep) titles.push('Artwork Cleanup & Production Prep');
      if (this.state.graphics === 'No Respekt custom design service') titles.push('Custom Topsheet + Base Graphic Design');
      return titles;
    }

    upgradeVariantId(title) {
      return this.data.upgradeVariants?.find((variant) => variant.title === title)?.id;
    }

    hasUnmappedUpgrade() {
      return this.selectedUpgradeTitles().some((title) => !this.upgradeVariantId(title));
    }

    selectedBoardVariant() {
      const variants = this.data.boardVariants || [];
      const optionNames = (this.data.boardOptions || []).map((name) => String(name).toLowerCase());
      const shapeIndex = optionNames.indexOf('shape');
      const sizeIndex = optionNames.indexOf('size');
      // Keep the current single-variant product working during migration.
      if (shapeIndex < 0 && sizeIndex < 0 && variants.length === 1 && variants[0].title === 'Default Title') return variants[0];
      if (shapeIndex < 0 || sizeIndex < 0) return null;
      return variants.find((variant) => variant.available &&
        String(variant.options[shapeIndex]) === String(this.state.shape) &&
        String(variant.options[sizeIndex]) === String(this.state.size)) || null;
    }

    syncBoardVariant() {
      const variant = this.selectedBoardVariant();
      const variantInput = this.form.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = variant ? String(variant.id) : '';
      if (variant) this.dataset.basePrice = String(variant.price);
      return variant;
    }

    hasUnmappedBoard() {
      return !this.selectedBoardVariant();
    }

    async submitBuild(event) {
      event.preventDefault();
      const firstMissing = ['shape','size','camber','flex'].find((key) => !this.state[key]);
      if (firstMissing) {
        this.querySelector(`[data-step="${firstMissing === 'size' ? 'shape' : firstMissing}"]`)?.scrollIntoView({behavior:'smooth',block:'start'});
        return;
      }
      this.syncBoardVariant();
      if (!this.data.cartEnabled || !this.data.hasProduct || this.hasUnmappedBoard() || this.hasUnmappedUpgrade()) {
        const status = this.querySelector('[data-status]');
        if (status) status.textContent = 'Checkout needs a quick pricing connection before this build can be added.';
        return;
      }

      const submit = this.querySelector('[data-submit]');
      const originalLabel = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Adding your build…';
      const cartRoot = window.Shopify?.routes?.root || '/';
      const cartAddUrl = `${cartRoot.replace(/\/$/, '')}/cart/add.js`;

      try {
        const baseResponse = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form)
        });
        if (!baseResponse.ok) throw new Error('Unable to add the custom board.');

        const upgrades = this.selectedUpgradeTitles().map((title) => ({
          id: this.upgradeVariantId(title),
          quantity: 1,
          properties: { _linked_custom_board_upgrade: title }
        }));
        if (upgrades.length) {
          const upgradesResponse = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: upgrades })
          });
          if (!upgradesResponse.ok) throw new Error('The board was added, but an upgrade could not be added.');
        }
        window.location.assign(`${cartRoot}cart`);
      } catch (error) {
        const status = this.querySelector('[data-status]');
        if (status) status.textContent = error.message || 'We could not add this build to the cart. Please try again.';
        submit.disabled = false;
        submit.textContent = originalLabel;
      }
    }

    updateUpgradePrice() {
      const price = this.querySelector('[data-pro-upgrade-price]');
      if (price) price.textContent = this.state.flexName ? '+ ' + this.formatMoney(this.proSurcharge()) + ' upgrade' : 'Choose a flex for upgrade pricing';
      const summary = this.querySelector('[data-summary-upgrade]');
      if (summary) summary.textContent = this.state.construction !== 'Pro' ? 'Included' : this.state.flexName ? '+ ' + this.formatMoney(this.proSurcharge()) : 'Choose a flex';
      const note = this.querySelector('[data-pro-price-note]');
      if (note) note.hidden = !this.hasUnmappedUpgrade();
    }

    updateGraphics() {
      const uploading = this.state.graphics === 'Customer supplied artwork';
      const designing = this.state.graphics === 'No Respekt custom design service';
      const uploadPanel = this.querySelector('[data-artwork-upload-panel]');
      const briefPanel = this.querySelector('[data-design-brief-panel]');
      const uploads = this.querySelectorAll('[data-artwork-upload]');
      const artworkPrep = this.querySelector('[data-artwork-prep]');
      const customDesignFee = this.querySelector('[data-custom-design-fee]');
      const brief = this.querySelector('[data-design-brief-panel] textarea');
      if (uploadPanel) uploadPanel.hidden = !uploading;
      if (briefPanel) briefPanel.hidden = !designing;
      uploads.forEach((upload) => { upload.disabled = !uploading; });
      if (artworkPrep) { artworkPrep.disabled = !uploading; artworkPrep.checked = uploading && this.state.artworkPrep; }
      if (customDesignFee) customDesignFee.disabled = !designing;
      if (brief) brief.disabled = !designing;
    }

    updateSummary() {
      const values = {
        shape:this.state.shape || 'Not selected', size:this.state.size ? `${this.state.size} cm` : 'Not selected',
        camber:this.state.camber || 'Not selected', flex:this.state.flex || 'Not selected',
        construction:this.state.construction, carbon:this.state.carbon,
        graphics:this.state.graphics || 'Not selected'
      };
      Object.entries(values).forEach(([key,value]) => { const target = this.querySelector(`[data-summary="${key}"]`); if (target) target.textContent = value; });
      this.querySelector('[data-summary-carbon-row]').hidden = this.state.construction !== 'Pro';
      const graphicsSurcharge = this.graphicsSurcharge();
      const graphicsUpgradeRow = this.querySelector('[data-summary-graphics-upgrade-row]');
      const graphicsUpgrade = this.querySelector('[data-summary-graphics-upgrade]');
      if (graphicsUpgradeRow) graphicsUpgradeRow.hidden = graphicsSurcharge === 0;
      if (graphicsUpgrade) graphicsUpgrade.textContent = `+ ${this.formatMoney(graphicsSurcharge)}`;
      const artworkRow = this.querySelector('[data-summary-artwork-row]');
      const artworkNames = [
        this.state.topArtworkName ? `Top: ${this.state.topArtworkName}` : '',
        this.state.baseArtworkName ? `Base: ${this.state.baseArtworkName}` : ''
      ].filter(Boolean).join(' · ');
      if (artworkRow) artworkRow.hidden = !artworkNames;
      const artwork = this.querySelector('[data-summary-artwork]');
      if (artwork) artwork.textContent = artworkNames || '—';
      const completed = [this.state.shape && this.state.size, this.state.camber, this.state.flex, this.state.construction].filter(Boolean).length;
      this.querySelector('[data-summary-progress]').textContent = `${completed} / 4`;
      const submit = this.querySelector('[data-submit]');
      const complete = this.isComplete();
      submit.disabled = !complete || Boolean(this.data.cartEnabled && this.data.hasProduct && (this.hasUnmappedBoard() || this.hasUnmappedUpgrade()));
      const status = this.querySelector('[data-status]');
      if (!this.state.shape || !this.state.size) status.textContent = 'Choose a shape and size to begin.';
      else if (!this.state.camber) status.textContent = 'Next: choose a camber profile.';
      else if (!this.state.flex) status.textContent = 'Next: choose your flex.';
      else if (this.data.cartEnabled && this.data.hasProduct && this.hasUnmappedBoard()) status.textContent = this.data.variantUnavailableMessage;
      else if (this.data.cartEnabled && this.data.hasProduct && this.hasUnmappedUpgrade()) status.textContent = 'Your build is complete. We need to verify the selected upgrade before checkout.';
      else if (!this.state.graphics) status.textContent = 'Your board build is ready. Choose a graphic direction or keep it clean.';
      else status.textContent = 'Your board configuration is complete.';
      const total = this.querySelector('[data-total-price]');
      if (total) {
        const cents = Number(this.dataset.basePrice) + (this.state.construction === 'Pro' ? this.proSurcharge() : 0) + this.graphicsSurcharge();
        total.textContent = this.formatMoney(cents);
      }
    }

    isComplete() { return Boolean(this.state.shape && this.state.size && this.state.camber && this.state.flex && this.state.construction); }
    escape(value) { const span = document.createElement('span'); span.textContent = value; return span.innerHTML; }
    formatMoney(cents) {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
      return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(cents / 100);
    }
  });
}
